import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import { notification, Popconfirm } from "antd";
import { Button } from "antd";
import AxiosAPI from "../scripts/AxiosAPI";

interface DataType {
  key: string;
  name: string;
  points: any;
  action: any;
}

type DataIndex = keyof DataType;

function DeleteButtonLevel({onDeleteItem, item}:any) {
  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    name: "",
    points: 0,
  });

  const [confirmDeleteOpened, setConfirmDeleteOpened] = useState(false);
  const [confirmDeleteLoading, setConfirmDeleteLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const handleDeleteOk = () => {
    setConfirmDeleteLoading(true);

    AxiosAPI.deleteRewardsLevel(item.id)
      .then((res: any) => {
        console.log(res.data);
        setConfirmDeleteOpened(false);
        setConfirmDeleteLoading(false);
        api.info({
          message: `Completed`,
          description: `${item.name} has been deleted successfully!`,
          placement: `topRight`,
        });
        onDeleteItem(item)
      })
      .catch(() => {});
  };

  const handleDeleteCancel = () => {
    console.log("Clicked cancel button");
    setConfirmDeleteOpened(false);
  };

  const deleteItem = (item: any) => {

    setConfirmDeleteLoading(false);

    setConfirmDeleteOpened(true);

    console.log("deleteThisItem::", item);

  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        title="Delete Level"
        description={`Are you sure you want to delete ${item.name}`}
        open={confirmDeleteOpened}
        onConfirm={handleDeleteOk}
        okButtonProps={{ loading: confirmDeleteLoading }}
        onCancel={handleDeleteCancel}
      >
        <Button
          type="default"
          size="large"
          onClick={deleteItem}
        >
          Delete Level
        </Button>
      </Popconfirm>
    </>
  );
}

export default DeleteButtonLevel;
